import CustomFields from '../modules/CustomFields'
import Forms from '../modules/Forms'
import Positions from '../modules/Positions'

/**
 * Add modules here.
 */

export default [CustomFields, Forms, Positions]



// WEBPACK FOOTER //
// ./src/config/modules.js